import React from 'react';
import I18n from '@/modules/i18n';
import ReactSelect5 from '@/components/common/ReactSelect5/ReactSelect5';
import Text from '@/components/ui/Text';

type TimeoutOption = { label: string; value: number };

interface SessionTimeoutSelectProps {
  initialValue: string;
  onChange: (value: number) => void;
  options: Record<string, number>;
  value: number;
}

const SessionTimeoutSelect = ({
  initialValue,
  onChange,
  options,
  value,
}: SessionTimeoutSelectProps) => {
  const values: TimeoutOption[] = Object.keys(options).map(key => ({ label: key, value: options[key] }));

  const selectedOption = values.find(v => v.value === value)
    ?? { label: initialValue, value };

  return (
    <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
      <div>
        <Text size="sm" tag="span" weight="bold">
          {I18n.t('session_timeout')}
        </Text>
        <Text className="tw-text-very-dark-grey" size="sm">
          {I18n.t('session_timeout_description')}
        </Text>
      </div>
      <div className="tw-shrink-0 tw-w-28">
        <ReactSelect5
          options={values}
          value={selectedOption}
          onChange={(option: TimeoutOption) => onChange(option.value)}
        />
      </div>
    </div>
  );
};

export default SessionTimeoutSelect;
